/** 
  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import Icon from "@mui/material/Icon";
import Account from "layouts/account";
import Accounts from "layouts/accounts";
import SystemAdmins from "layouts/system_admins";
import permissions from "./config/permissions";
import Payments from "./layouts/payments";
import SimpleProfile from "./layouts/simple_profile/simple_profile";
import Consumptions from "./layouts/consumptions";
import Organizations from "./layouts/organizations";
import Configurations from "./layouts/configurations";
import PaymentSettlement from "./layouts/payment_settlement";
import ConsumptionSummary from "layouts/consumption_summary";
import PaymentHistory from "layouts/payment_history";
import PaymentSummary from "layouts/payment_summary";

const routes = [
  {
    type: "collapse",
    name: "Organizations",
    key: "organizations",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/organizations",
    component: <Organizations />,
    permissions: permissions().organization().read().list(),
  },
  {
    type: "collapse",
    name: "Accounts",
    key: "accounts",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/accounts",
    component: <Accounts />,
    permissions: permissions().account().read().list(),
    collapse: [
      {
        type: "collapse",
        name: "Accounts",
        key: "accounts",
        icon: <Icon fontSize="small">account_circle</Icon>,
        route: "/accounts",
        component: <Accounts />,
        permissions: permissions().account().read().list(),
      },
      {
        type: "collapse",
        name: "Accounts",
        key: "accounts/id",
        icon: <Icon fontSize="small">account_circle</Icon>,
        route: "/accounts/:id",
        component: <Account />,
        permissions: permissions().account().read().list(),
      },
    ],
  },
  {
    type: "collapse",
    name: "Consumption",
    key: "consumption",
    icon: <Icon fontSize="small">speed</Icon>,
    route: "/consumptions",
    component: <Consumptions />,
    permissions: permissions().consumption().create().list(),
  },
  {
    type: "collapse",
    name: "Payments",
    key: "payments",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/payments",
    component: <Payments />,
    permissions: permissions().payment().create().list(),
  },
  {
    type: "collapse",
    name: "Consumption Summary",
    key: "consumption_summary",
    icon: <Icon fontSize="small">functions</Icon>,
    route: "/consumption_summary",
    component: <ConsumptionSummary />,
    permissions: permissions().consumptionSummary().read().list(),
  },
  {
    type: "collapse",
    name: "Payment Summary",
    key: "payment_summary",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/payment_summary",
    component: <PaymentSummary />,
    permissions: permissions().payment().create().list(),
  },
  {
    type: "collapse",
    name: "Payment History",
    key: "payment_history",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/payment_history",
    component: <PaymentHistory />,
    permissions: permissions().paymentHistory().read().list(),
  },
  {
    type: "collapse",
    name: "Payment Settlements",
    key: "payment_settlements",
    icon: <Icon fontSize="small">credit_score</Icon>,
    route: "/payment_settlements",
    component: <PaymentSettlement />,
    permissions: permissions().paymentSettlement().read().list(),
  },
  {
    type: "collapse",
    name: "System Admins",
    key: "system_admins",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/system_admins",
    component: <SystemAdmins />,
    permissions: permissions().systemAdmin().read().list(),
  },
  {
    type: "collapse",
    name: "Configurations",
    key: "configurations",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/configurations",
    component: <Configurations />,
    permissions: permissions().orgConfig().read().list(),
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <SimpleProfile />,
    permissions: permissions().profile().read().list(),
  },
];

export default routes;
